import { Component } from '@angular/core';

@Component({
  selector: 'app-profile-created',
  templateUrl: './profile-created.component.html',
  styleUrls: ['./profile-created.component.scss'],
})
/**
 * Confirms the profile creation
 */
export class ProfileCreatedComponent {}
